import libdict from "@/api/dict";
const common = {
  state: {
    libdict: libdict
  }
};

export default common;



// WEBPACK FOOTER //
// ./src/store/common.js